import { styled } from "styled-components";

import { colorCSS, cssColorsFromBackgroundField, minWidth } from "../../styles";
import { redundantCssFromKebab } from "../../styles/redundant-css";

export const Tab = styled.button`
    ${cssColorsFromBackgroundField({ color: "P75" })}
    ${redundantCssFromKebab("border-radius", "21px")}
    ${redundantCssFromKebab("border", "3px solid transparent")}
    ${redundantCssFromKebab("padding", "0.5rem 1.5rem")}
    &[aria-selected="true"] {
        ${cssColorsFromBackgroundField({ color: "P500" }) || ""}
    }
    &:hover,
    :focus,
    :active {
        ${redundantCssFromKebab("border", `3px solid ${colorCSS("B300")}`)}
        ${redundantCssFromKebab("outline", "none")}
    }
`;

export const TabList = styled.div`
    ${redundantCssFromKebab("display", "flex")}
    ${redundantCssFromKebab("justify-content", "center")}
    ${redundantCssFromKebab("flex-wrap", "wrap")}
    ${redundantCssFromKebab("gap", "0.5rem")}
    ${redundantCssFromKebab("margin", "0 auto")}
    ${redundantCssFromKebab("max-width", "100%")}
    ${redundantCssFromKebab("padding", "1rem")}
    
    @media (min-width: 576px) {
        max-width: 540px;
    }

    @media (min-width: 768px) {
        max-width: 720px;
    }

    @media ${minWidth.lg} {
        ${redundantCssFromKebab("flex-wrap", "nowrap")}
        max-width: 960px;
    }

    @media (min-width: 1200px) {
        max-width: 1140px;
    }
`;

export const Tabs = styled.div`
    ${redundantCssFromKebab("display", "flex")}
    ${redundantCssFromKebab("justify-content", "center")}
    ${redundantCssFromKebab("margin", "0 auto")}
    ${redundantCssFromKebab("max-width", "100%")}
    ${redundantCssFromKebab("padding", "0 1rem")}
`;

export const TabPanel = styled.div`
    ${redundantCssFromKebab("padding-top", "1rem")}
    &.is-hidden {
        ${redundantCssFromKebab("display", "none")}
    }
`;

export const Title = styled.h2`
    ${redundantCssFromKebab("margin", "0 auto")}
    ${redundantCssFromKebab("max-width", "100%")}
    ${redundantCssFromKebab("padding", "1rem 1rem 2rem")}
    ${redundantCssFromKebab("text-align", "center")}
    
    @media (min-width: 576px) {
        max-width: 540px;
    }

    @media (min-width: 768px) {
        max-width: 720px;
    }

    @media (min-width: 992px) {
        max-width: 960px;
    }

    @media (min-width: 1200px) {
        max-width: 1140px;
    }
`;
